export default "__VITE_ASSET__a3255f0f__"